var React = require('react');

function Like (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h16v16H0z","key":0}),React.createElement("circle",{"cx":"8","cy":"8","r":"7","stroke":"#7A60C1","strokeWidth":"2","key":1}),React.createElement("g",{"stroke":"#7A60C1","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":2},React.createElement("path",{"d":"M5 7.5L8 5l3 2.5M8 5v6"}))]));
}

Like.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Like;

Like.default = Like;
